// pages/admins/permissions/PermissionFilterBar.jsx
//
// Section 3 from the redesign brief: search + state filter + module filter
// + a quick "only changed" switch, kept sticky while the module list below
// scrolls. Purely a controlled view over already-fetched data (same
// `moduleSearch`/`statusFilter`/`moduleFilterId` state AccessManagement
// UsersPage.jsx already owned) -- no new fetch, no new filtering rule
// beyond the existing STATUS_FILTERS enum.
import React from "react";
import { Form } from "react-bootstrap";
import { STATUS_FILTERS } from "./permissionUtils";

export default function PermissionFilterBar({
  search, onSearchChange,
  statusFilter, onStatusFilterChange,
  moduleFilterId, onModuleFilterChange,
  modules,
}) {
  const onlyChanged = statusFilter === "OVERRIDES";
  return (
    <div className="pm-filter-bar">
      <div className="aup-filter-search pm-filter-search">
        <span className="aup-search-icon" aria-hidden="true"><i className="fa-solid fa-magnifying-glass"></i></span>
        <Form.Control
          placeholder="Search modules or permissions…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label="Search modules or permissions"
        />
      </div>
      <Form.Select
        size="sm"
        value={statusFilter}
        onChange={(e) => onStatusFilterChange(e.target.value)}
        aria-label="Filter permissions by state"
        className="aup-matrix-filter-select"
      >
        {STATUS_FILTERS.map((f) => <option key={f.key} value={f.key}>{f.label}</option>)}
      </Form.Select>
      <Form.Select
        size="sm"
        value={moduleFilterId}
        onChange={(e) => onModuleFilterChange(e.target.value)}
        aria-label="Filter by module"
        className="aup-matrix-filter-select"
      >
        <option value="">All Modules</option>
        {modules.map((m) => <option key={m.id} value={m.id}>{m.moduleName}</option>)}
      </Form.Select>
      <label className="pm-only-changed">
        <input
          type="checkbox"
          checked={onlyChanged}
          onChange={(e) => onStatusFilterChange(e.target.checked ? "OVERRIDES" : "")}
        />
        <span className="pm-only-changed-track" aria-hidden="true"><span className="pm-only-changed-thumb" /></span>
        Only changed
      </label>
    </div>
  );
}
